import { HorizontalScrollDirection } from '../../domain/direction';
import { SCROLL_EDGE_THRESHOLD } from './scroll-options-strategy';
import type { ExtendedScrollToOptions } from '@angular/cdk/scrolling';
import type { ScrollOptionsStrategy } from './scroll-options-strategy';
import type { ScrollableDirective } from './scrollable.directive';

export class DefaultScrollOptionsStrategy implements ScrollOptionsStrategy {

  /** Attaches this position strategy to an overlay. */
  scroll(direction: HorizontalScrollDirection, scrollable: ScrollableDirective): ExtendedScrollToOptions {
    const scrollOffset = scrollable.measureScrollOffset(direction);

    if (scrollOffset > SCROLL_EDGE_THRESHOLD) {
      const scrollEndPoint = scrollOffset < scrollable.scrollSize ?
        0 : scrollOffset - scrollable.scrollSize;

      const scrollToOptions: ExtendedScrollToOptions = direction === HorizontalScrollDirection.LEFT ?
        { left: scrollEndPoint, behavior: 'smooth' } : { right: scrollEndPoint, behavior: 'smooth' };

      scrollable.scrollTo(scrollToOptions);

      return scrollToOptions;
    }
  }
}
